module.exports = __webpack_public_path__ + "img/mine-giftbig.cfe05387.webp";